const minimalHeader = {
  init() {
    this.initScrollBehavior();
  },

  initScrollBehavior() {
    const el = document.querySelector('header.minimal-header');
    if (!el) return;

    let lastY = window.scrollY;
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        const currentY = window.scrollY;

        if (currentY > lastY && currentY > el.offsetHeight) {
          el.classList.add('header--hidden');
        } else {
          el.classList.remove('header--hidden');
        }

        lastY = currentY;
        ticking = false;
      });
    }, { passive: true });
  },
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => minimalHeader.init());
} else {
  minimalHeader.init();
}
